import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Section = ({ children, className = "", ...rest }) => (
  <section className={`py-20 sm:py-28 ${className}`} {...rest}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">{children}</div>
  </section>
);

export const Eyebrow = ({ children, color = "sage" }) => (
  <div
    className={`text-xs tracking-[0.25em] uppercase mb-5 ${
      color === "gold" ? "text-brand-gold" : "text-brand-sage"
    }`}
  >
    {children}
  </div>
);

export const SerifH = ({ as = "h2", children, className = "" }) => {
  const Tag = as;
  return (
    <Tag
      className={`font-serif text-brand-green leading-[1.05] tracking-tight ${className}`}
    >
      {children}
    </Tag>
  );
};

export const PrimaryButton = ({ to, href, children, testid, onClick, type, className = "" }) => {
  const cls = `inline-flex items-center justify-center gap-2 bg-brand-green text-white rounded-full px-7 py-3.5 text-sm font-medium tracking-wide hover:bg-brand-navy transition-all hover:-translate-y-0.5 ${className}`;
  if (to)
    return (
      <Link to={to} data-testid={testid} className={cls}>
        {children} <ArrowUpRight className="w-4 h-4" />
      </Link>
    );
  if (href)
    return (
      <a href={href} data-testid={testid} className={cls}>
        {children} <ArrowUpRight className="w-4 h-4" />
      </a>
    );
  return (
    <button data-testid={testid} onClick={onClick} type={type || "button"} className={cls}>
      {children}
    </button>
  );
};

export const SecondaryButton = ({ to, children, testid, className = "" }) => {
  const cls = `inline-flex items-center justify-center gap-2 bg-transparent text-brand-green border border-brand-green/70 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide hover:bg-brand-mist hover:-translate-y-0.5 transition-all ${className}`;
  if (to)
    return (
      <Link to={to} data-testid={testid} className={cls}>
        {children}
      </Link>
    );
  return (
    <button data-testid={testid} className={cls}>
      {children}
    </button>
  );
};

export const Bullet = ({ children }) => (
  <li className="flex items-start gap-3 text-slate-700 text-[15px] leading-relaxed">
    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-gold flex-shrink-0" />
    <span>{children}</span>
  </li>
);

export const Card = ({ children, className = "" }) => (
  <div
    className={`bg-white border border-brand-green/10 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 ${className}`}
  >
    {children}
  </div>
);
